export interface PerfilUsuario {
  id: string;
  nome: string;
  email: string;
  telefone: string;
  cpf: string;
  dataNascimento: string;
  tipo: 'participante' | 'empresa';
  empresaNome?: string;
  empresaId?: string;
  status: 'ativo' | 'inativo' | 'pendente' | 'bloqueado';
  dataCadastro: string;
  ultimoAcesso: string;
  endereco: {
    logradouro: string;
    numero: string;
    complemento?: string;
    bairro: string;
    cidade: string;
    estado: string;
    cep: string;
  };
  contatoAlternativo?: string;
  observacoes?: string;
  mfaHabilitado?: boolean;
  ultimaAlteracaoSenha?: string;
  tentativasLoginFalhas?: number;
  ultimaTentativaLogin?: string;
  dispositivosAtivos?: number;
  ipUltimoAcesso?: string;
  tokenResetPendente?: boolean;
  tokenResetEnviadoEm?: string;
  tokenResetCanal?: 'email' | 'sms' | 'whatsapp';
  historicoTokens?: Array<{
    tipo: 'login' | 'reset_senha' | '2fa' | 'verificacao';
    canal: 'email' | 'sms' | 'whatsapp';
    enviadoEm: string;
    expiraEm: string;
    status: 'pendente' | 'usado' | 'expirado' | 'cancelado';
    codigoMascarado?: string;
  }>;
}

export const perfisUsuarios: PerfilUsuario[] = [
  {
    id: 'PART-001',
    nome: 'João Pedro Silva',
    email: 'joao.silva@email.com',
    telefone: '(11) 98765-4321',
    cpf: '123.456.789-01',
    dataNascimento: '1992-03-15',
    tipo: 'participante',
    status: 'ativo',
    dataCadastro: '2025-02-10T08:30:00Z',
    ultimoAcesso: '2026-05-08T09:00:00Z',
    endereco: {
      logradouro: 'Rua Augusta',
      numero: '1500',
      complemento: 'Apto 42',
      bairro: 'Consolação',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01305-100',
    },
    observacoes: 'Participante ativo há 15 meses. Nunca teve chamados abertos antes deste.',
    mfaHabilitado: false,
    ultimaAlteracaoSenha: '2025-11-20T14:00:00Z',
    tentativasLoginFalhas: 0,
    dispositivosAtivos: 2,
    ipUltimoAcesso: '187.45.123.89',
    historicoTokens: [
      { tipo: 'login', canal: 'email', enviadoEm: '2026-05-08T08:55:00Z', expiraEm: '2026-05-08T09:25:00Z', status: 'usado', codigoMascarado: '***423' },
      { tipo: '2fa', canal: 'sms', enviadoEm: '2026-05-07T16:00:00Z', expiraEm: '2026-05-07T16:10:00Z', status: 'usado', codigoMascarado: '***891' },
    ],
  },
  {
    id: 'EMP-001',
    nome: 'Ricardo Ferreira',
    email: 'ricardo@inovacaodigital.com.br',
    telefone: '(11) 91234-5678',
    cpf: '987.654.321-09',
    dataNascimento: '1985-07-22',
    tipo: 'empresa',
    empresaNome: 'Inovação Digital Ltda',
    empresaId: 'EMP-002',
    status: 'ativo',
    dataCadastro: '2025-06-15T14:00:00Z',
    ultimoAcesso: '2026-05-07T16:30:00Z',
    endereco: {
      logradouro: 'Av. Paulista',
      numero: '2000',
      bairro: 'Bela Vista',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01310-200',
    },
    contatoAlternativo: '(11) 99999-0000',
    observacoes: 'Responsável pelo cadastro da empresa. Primeira vez que abre chamado.',
    mfaHabilitado: true,
    ultimaAlteracaoSenha: '2026-02-10T10:00:00Z',
    tentativasLoginFalhas: 2,
    ultimaTentativaLogin: '2026-05-07T16:28:00Z',
    dispositivosAtivos: 1,
    ipUltimoAcesso: '201.18.45.77',
    historicoTokens: [
      { tipo: 'verificacao', canal: 'email', enviadoEm: '2025-06-15T14:05:00Z', expiraEm: '2025-06-15T14:35:00Z', status: 'usado', codigoMascarado: '***112' },
    ],
  },
  {
    id: 'EMP-002',
    nome: 'Fernanda Costa',
    email: 'fernanda@techbrasil.com.br',
    telefone: '(21) 98765-1234',
    cpf: '456.789.123-45',
    dataNascimento: '1988-11-30',
    tipo: 'empresa',
    empresaNome: 'TechBrasil S.A.',
    empresaId: 'EMP-003',
    status: 'ativo',
    dataCadastro: '2024-08-20T10:15:00Z',
    ultimoAcesso: '2026-05-06T11:00:00Z',
    endereco: {
      logradouro: 'Rua Visconde de Pirajá',
      numero: '500',
      complemento: 'Sala 301',
      bairro: 'Ipanema',
      cidade: 'Rio de Janeiro',
      estado: 'RJ',
      cep: '22410-001',
    },
    observacoes: 'Participante frequente. Abre chamados sobre conciliação de vendas.',
    mfaHabilitado: false,
    ultimaAlteracaoSenha: '2025-09-01T09:00:00Z',
    tentativasLoginFalhas: 5,
    ultimaTentativaLogin: '2026-05-06T10:55:00Z',
    dispositivosAtivos: 3,
    ipUltimoAcesso: '177.23.112.44',
    tokenResetPendente: true,
    tokenResetEnviadoEm: '2026-05-06T10:30:00Z',
    tokenResetCanal: 'sms',
    historicoTokens: [
      { tipo: 'reset_senha', canal: 'sms', enviadoEm: '2026-05-06T10:30:00Z', expiraEm: '2026-05-06T11:00:00Z', status: 'pendente', codigoMascarado: '***556' },
      { tipo: 'login', canal: 'email', enviadoEm: '2026-05-05T08:00:00Z', expiraEm: '2026-05-05T08:30:00Z', status: 'expirado', codigoMascarado: '***901' },
    ],
  },
  {
    id: 'EMP-003',
    nome: 'Paulo Henrique',
    email: 'paulo@sistemasintegrados.com.br',
    telefone: '(31) 91234-8765',
    cpf: '789.123.456-78',
    dataNascimento: '1979-01-10',
    tipo: 'empresa',
    empresaNome: 'Sistemas Integrados BH',
    empresaId: 'EMP-004',
    status: 'ativo',
    dataCadastro: '2025-01-05T09:00:00Z',
    ultimoAcesso: '2026-05-08T07:45:00Z',
    endereco: {
      logradouro: 'Av. Afonso Pena',
      numero: '3000',
      bairro: 'Centro',
      cidade: 'Belo Horizonte',
      estado: 'MG',
      cep: '30130-002',
    },
    contatoAlternativo: '(31) 99876-5432',
    observacoes: 'Empresa com alto volume de compra de pontos. Solicitou reembolso anteriormente.',
    mfaHabilitado: false,
    ultimaAlteracaoSenha: '2025-12-15T11:00:00Z',
    tentativasLoginFalhas: 1,
    dispositivosAtivos: 1,
    ipUltimoAcesso: '189.56.34.12',
    historicoTokens: [
      { tipo: 'login', canal: 'email', enviadoEm: '2026-05-08T07:40:00Z', expiraEm: '2026-05-08T08:10:00Z', status: 'usado', codigoMascarado: '***234' },
    ],
  },
  {
    id: 'PART-002',
    nome: 'Beatriz Santos',
    email: 'bia.santos@email.com',
    telefone: '(11) 99988-7766',
    cpf: '321.654.987-12',
    dataNascimento: '1995-09-25',
    tipo: 'participante',
    status: 'ativo',
    dataCadastro: '2025-04-12T16:45:00Z',
    ultimoAcesso: '2026-05-05T10:20:00Z',
    endereco: {
      logradouro: 'Rua Oscar Freire',
      numero: '800',
      bairro: 'Jardins',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '01426-001',
    },
    observacoes: 'Usuário do app premiado. Teve problema com login que foi resolvido.',
    mfaHabilitado: false,
    ultimaAlteracaoSenha: '2025-10-01T15:00:00Z',
    tentativasLoginFalhas: 0,
    dispositivosAtivos: 2,
    ipUltimoAcesso: '201.33.67.89',
    historicoTokens: [
      { tipo: 'reset_senha', canal: 'email', enviadoEm: '2026-04-28T09:00:00Z', expiraEm: '2026-04-28T09:30:00Z', status: 'usado', codigoMascarado: '***778' },
    ],
  },
  {
    id: 'EMP-004',
    nome: 'Luciana Almeida',
    email: 'luciana@empresaexemplo.com.br',
    telefone: '(47) 98877-6655',
    cpf: '654.987.321-54',
    dataNascimento: '1990-06-18',
    tipo: 'empresa',
    empresaNome: 'Empresa Exemplo Ltda',
    empresaId: 'EMP-007',
    status: 'ativo',
    dataCadastro: '2024-11-01T11:30:00Z',
    ultimoAcesso: '2026-05-04T14:00:00Z',
    endereco: {
      logradouro: 'Rua 500',
      numero: '120',
      bairro: 'Centro',
      cidade: 'Blumenau',
      estado: 'SC',
      cep: '89010-001',
    },
    observacoes: 'Empresa no plano Básico. Poucos chamados abertos.',
    mfaHabilitado: false,
    ultimaAlteracaoSenha: '2025-08-20T13:00:00Z',
    tentativasLoginFalhas: 0,
    dispositivosAtivos: 1,
    ipUltimoAcesso: '189.78.45.33',
    historicoTokens: [
      { tipo: 'login', canal: 'email', enviadoEm: '2026-05-04T13:50:00Z', expiraEm: '2026-05-04T14:20:00Z', status: 'usado', codigoMascarado: '***345' },
    ],
  },
  {
    id: 'PART-003',
    nome: 'Roberto Dias',
    email: 'roberto.dias@email.com',
    telefone: '(19) 97766-5544',
    cpf: '147.258.369-00',
    dataNascimento: '1983-12-05',
    tipo: 'participante',
    status: 'ativo',
    dataCadastro: '2025-08-01T07:15:00Z',
    ultimoAcesso: '2026-05-08T06:30:00Z',
    endereco: {
      logradouro: 'Av. Brasil',
      numero: '150',
      complemento: 'Bloco B',
      bairro: 'Jardim das Oliveiras',
      cidade: 'Campinas',
      estado: 'SP',
      cep: '13084-010',
    },
    observacoes: 'Participante com histórico de saques regulares. Reclamação de atraso recorrente.',
    mfaHabilitado: true,
    ultimaAlteracaoSenha: '2026-03-05T16:00:00Z',
    tentativasLoginFalhas: 0,
    dispositivosAtivos: 2,
    ipUltimoAcesso: '177.89.123.44',
    historicoTokens: [
      { tipo: '2fa', canal: 'sms', enviadoEm: '2026-05-08T06:25:00Z', expiraEm: '2026-05-08T06:35:00Z', status: 'usado', codigoMascarado: '***667' },
      { tipo: 'login', canal: 'email', enviadoEm: '2026-05-07T20:00:00Z', expiraEm: '2026-05-07T20:30:00Z', status: 'usado', codigoMascarado: '***123' },
    ],
  },
  {
    id: 'EMP-005',
    nome: 'Amanda Rocha',
    email: 'amanda@consultoratech.com.br',
    telefone: '(11) 96655-4433',
    cpf: '852.741.963-21',
    dataNascimento: '1993-04-08',
    tipo: 'empresa',
    empresaNome: 'Consultoria Tech Solutions',
    empresaId: 'EMP-008',
    status: 'ativo',
    dataCadastro: '2025-03-20T13:00:00Z',
    ultimoAcesso: '2026-05-07T09:45:00Z',
    endereco: {
      logradouro: 'Av. Brigadeiro Faria Lima',
      numero: '3500',
      bairro: 'Itaim Bibi',
      cidade: 'São Paulo',
      estado: 'SP',
      cep: '04538-132',
    },
    contatoAlternativo: '(11) 95544-3322',
    observacoes: 'Usa intensamente relatórios de performance. Teve instabilidade no servidor.',
    mfaHabilitado: true,
    ultimaAlteracaoSenha: '2026-01-15T09:00:00Z',
    tentativasLoginFalhas: 0,
    dispositivosAtivos: 2,
    ipUltimoAcesso: '201.90.55.77',
    historicoTokens: [
      { tipo: 'verificacao', canal: 'whatsapp', enviadoEm: '2026-05-07T09:40:00Z', expiraEm: '2026-05-07T09:50:00Z', status: 'usado', codigoMascarado: '***889' },
    ],
  },
];

let perfisData = [...perfisUsuarios];

export function getPerfilPorEmail(email: string): PerfilUsuario | undefined {
  return perfisData.find((p) => p.email.toLowerCase() === email.toLowerCase());
}

export function atualizarPerfil(
  id: string,
  dados: Partial<PerfilUsuario>
): PerfilUsuario | undefined {
  const idx = perfisData.findIndex((p) => p.id === id);
  if (idx === -1) return undefined;
  perfisData[idx] = { ...perfisData[idx], ...dados };
  return perfisData[idx];
}

export function getPerfis(): PerfilUsuario[] {
  return perfisData;
}

export function getPerfilPorId(id: string): PerfilUsuario | undefined {
  return perfisData.find((p) => p.id === id);
}

export function getHistoricoTokensPorEmail(email: string): PerfilUsuario['historicoTokens'] {
  const perfil = getPerfilPorEmail(email);
  return perfil?.historicoTokens || [];
}

export function gerarTokenMock(canal: 'email' | 'sms' | 'whatsapp'): string {
  return Math.floor(100000 + Math.random() * 900000).toString();
}